import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
	BURGER_TOGGLE: '[data-fragment="MenuComponent.burgerToggle"]',
	BURGER_TEXT: '[data-fragment="MenuComponent.burgerText"]',
	NAVIGATION: '[data-fragment="MenuComponent.navigation"]',
	SEND_CV: '[data-fragment="MenuComponent.sendCV"]',
	SEND_CV_LINK: '[data-fragment="MenuComponent.sendCVLink"]',
	BACKDROP: '[data-fragment="MenuComponent.backdrop"]',
};



class MenuComponent extends WebComponent {

	constructor(props) {
		super(props);
		const {
			expanded = false,
			docWidth = this.getActualWidth()
		} = props;
		this.state = {
			expanded,
			docWidth
		};
	}

	didMount() {
		this.on('click', fragments.BURGER_TOGGLE, this.handleClickBurgerToggle);
		this.on('click', fragments.BACKDROP, this.handleClickBurgerToggle);
		this.burgerToggleElement = this.element.querySelector(fragments.BURGER_TOGGLE);
		this.burgerTextElement = this.element.querySelector(fragments.BURGER_TEXT);
		this.navigationElement = this.element.querySelector(fragments.NAVIGATION);
		this.sendCVElement = this.element.querySelector(fragments.SEND_CV);
		this.sendCVLinkElement = this.element.querySelector(fragments.SEND_CV_LINK);
		this.backdropElement = this.element.querySelector(fragments.BACKDROP);
		window.addEventListener("load", this.initMenu);
		window.addEventListener("resize", this.initMenu);
	}

	initMenu = (e) => {
		var actualWidth = this.getActualWidth();

		if(this.state.docWidth !== actualWidth){
			this.setState({
				expanded: false,
				docWidth: actualWidth
			});
		}

		if (window.innerWidth >= 480 && window.innerWidth < 1024) {
			this.element.insertBefore(this.sendCVLinkElement, this.element.firstChild);
		} else {
			this.sendCVElement.insertBefore(this.sendCVLinkElement, this.sendCVElement.firstChild);
		}

	}

	handleClickBurgerToggle = (e) => {
		e.preventDefault();
		const {
			expanded,
		} = this.state;

		this.setState({
			expanded: !expanded,
		});

		if(!expanded){
			document.documentElement.classList.add('navigation--open');
		} else {
			document.documentElement.classList.remove('navigation--open');
		}
	}

	willUnMount() {
		this.burgerToggleElement = null;
		this.burgerTextElement = null;
		this.navigationElement = null;
		this.sendCVElement = null;
		this.sendCVLinkElement = null;
		this.backdropElement = null;
	}

	update(prevProps, prevState, inDocument) {
		const {
			expanded,
		} = this.state;

		classNames(this.element, {
			'menu--open': expanded,
		});

		classNames(this.burgerToggleElement, {
			'menu-burger--close': expanded,
		});

		classNames(this.burgerToggleElement, {
			'menu-burger--show': !expanded,
		});

		classNames(this.navigationElement, {
			'navigation--expanded': expanded,
		});

		classNames(this.backdropElement, {
			'menu-backdrop--opened': expanded,
		});

		this.burgerTextElement.innerText = expanded ? this.i18n('close') : this.i18n('menu');
		this.navigationElement.setAttribute('aria-expanded', expanded);
	}

	getActualWidth = () => {
		return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || document.body.offsetWidth;
	}
}

MenuComponent.defaultProps = {
	messages: {
		menu: 'Menu',
		close: 'Zavřít',
	},
};

export default MenuComponent;




// WEBPACK FOOTER //
// ./fe/web-career/src/js/components/MenuComponent/MenuComponent.js